module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "xl",
      "type": "dark",
      "variant": "dark",
      "sticky": "",
      "fixed": ""
    }
  }, [_c('b-navbar-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png"),
      "height": "32"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), (_vm.authenticationService.isAuthenticated() === true) ? _c('b-nav-item', {
    attrs: {
      "to": "/workbench"
    }
  }, [_vm._v("SQL Workbench")]) : _vm._e(), _vm._v(" "), (_vm.authenticationService.isAuthenticated() === true) ? _c('b-nav-item', {
    attrs: {
      "to": "/filesystem"
    }
  }, [_vm._v("File System")]) : _vm._e()], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(_vm.authenticationService.isAuthenticated() === false) ? _c('b-nav-item', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]) : _vm._e(), _vm._v(" "), (_vm.authenticationService.isAuthenticated() === true) ? _c('b-nav-item-dropdown', {
    attrs: {
      "id": "user-dropdown",
      "text": _vm.user.displayName,
      "toggle-class": "nav-link-custom",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function() {
        return [_c('b-img', {
          attrs: {
            "src": _vm.user.imageUrl,
            "rounded": "circle",
            "width": "32"
          }
        }), _vm._v(" " + _vm._s(_vm.user.displayName) + "\r\n\t\t\t\t\t\t")]
      },
      proxy: true
    }], null, false, 2936113834)
  }, [_vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/user/password"
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Logout")])], 1) : _vm._e(), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "id": "help-dropdown",
      "text": "Help",
      "toggle-class": "nav-link-custom",
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": "/help"
    }
  }, [_vm._v("Help")]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "https://www.teedrei.com",
      "target": "new"
    }
  }, [_vm._v("Documentation")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cad49406","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 2148
// module chunks = 1